import * as _ from 'lodash'

import { BaseDto } from "../base.dto"
import { PagingDto } from "../paging.dto"
import { BaseError } from "../../errors"

export class ImageDto {
  id: string
  url: string
  name: string
  type: string
}

export class BannerHomeDto extends BaseDto {
  title: string
  titleKh: string
  url: string
  image: ImageDto
  mall: {
    id: string
    name: string,
    nameKh:string
  }
  mallId: string
  startTime: string
  endTime: string
  displayOrder: number
  displayStatus: boolean
  ownerId: string
}

export class FindBannerHomeDto extends PagingDto {
  displayStatus?: boolean
  mallId?: string
}

export class CreateBannerHomeDto {
  title?: string
  titleKh?: string
  imageId?: string
  mallId?: string
  startTime?: string
  endTime?: string
  displayOrder?: number
  displayStatus?: boolean
  url?: string
}

// State management interfaces
export interface BannerFilters {
  status: string | null;
  mall: string | null;
}

export interface BannerHomeState {
  banners: BannerHomeDto[];
  loading: boolean;
  error: BaseError | null;
  pageInfo: {
    page: number;
    pageSize: number;
    collectionSize: number;
    from: number;
    to: number;
  };
  filters: BannerFilters;
}

export interface BannerFormData {
  title: string;
  titleKh: string;
  displayOrder: number | null;
  url: string | null;
  startTime: string | null;
  endTime: string | null;
  mallId: string | null;
  displayStatus: boolean;
  imageId: string | null;
}

export interface BannerFormDataStatusOnly {
  displayStatus: boolean;
}

// Query and utility interfaces
export interface BannerQueryParams {
  limit: number;
  offset: number;
  displayStatus?: boolean;
  mallId?: string;
}

export type DateInput = string | Date | null;

export interface DisplayStatusUpdate {
  displayStatus: boolean;
}
